module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap p-t-lg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "p-t-md"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.evaluate_result.abilities && _vm.evaluate_result.abilities.length > 0) ? _c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "m-b-sm"
  }, [(_vm.evaluate.category === 2) ? _c('span', [_vm._v("岗位")]) : _vm._e(), _vm._v("测评报告详情\n            "), _c('span', {
    staticClass: "btn btn-primary right",
    on: {
      "click": function($event) {
        _vm.download()
      }
    }
  }, [_vm._v("下载报告")])]), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "report-area"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.evaluate.category === 2) ? _c('div', {
    staticClass: "row user-info p-b-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.tester.realname ? _vm.tester.realname : _vm.tester.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("邮箱:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.tester.email))])]), _vm._v(" "), (_vm.tester.phone) ? _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("手机:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.tester.phone))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("岗位:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.evaluate.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.tester.avatar) ? _c('img', {
    staticClass: "m-r-sm right",
    attrs: {
      "src": _vm.tester.avatar,
      "alt": "",
      "width": "100"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "b-b m-tb-sm "
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-border",
    attrs: {
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.evaluate_result.abilities), function(ability) {
    return _c('tbody', {
      key: ability._id
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "rowpan": ability.indicators.length
      }
    }, [_vm._v(_vm._s(ability.ability.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "rowpan": ability.indicators.length
      }
    }, [_vm._v(_vm._s(ability.score.toFixed(2)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "rowpan": ability.indicators.length
      }
    }, [_vm._v("超过\n                        "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s((ability.rate * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "rowpan": ability.indicators.length
      }
    }, [_vm._v("超过\n                        "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s((ability.entry_rate * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ability.indicators[0].indicator.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ability.indicators[0].score.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v("超过\n                        "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s((ability.indicators[0].rate * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('td', [_vm._v("超过\n                        "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s((ability.indicators[0].entry_rate * 100).toFixed(2)) + "%")])])]), _vm._v(" "), _vm._l(((ability.indicators.slice(1))), function(ind) {
      return _c('tr', {
        key: ind._id
      }, [_c('td', [_vm._v(_vm._s(ind.indicator.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ind.score.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v("超过\n                        "), _c('span', {
        staticClass: "num"
      }, [_vm._v(_vm._s((ind.rate * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('td', [_vm._v("超过\n                        "), _c('span', {
        staticClass: "num"
      }, [_vm._v(_vm._s((ind.entry_rate * 100).toFixed(2)) + "%")])])])
    })], 2)
  })], 2)]), _vm._v(" "), _vm._m(1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row p-t-b-md text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-md btn-primary",
    attrs: {
      "to": "/evaluate"
    }
  }, [_vm._v("参与更多测评，完善个人档案 >>")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowpan": "2"
    }
  }, [_vm._v("能力群")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowpan": "2"
    }
  }, [_vm._v("得分")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("得分排名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("详情")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("求职者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("在职人员")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("指标")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("得分")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("求职者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("在职人员")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("本报告由\n                  "), _c('a', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "href": "http://www.psych.cas.cn",
      "title": "中国科学院心理研究所",
      "alt": "中国科学院心理研究所"
    }
  }, [_vm._v("中国科学院心理研究所")]), _vm._v(" 提供测评技术支持")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9d2a456","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/evaluate/detail.vue
// module id = 502
// module chunks = 1